import styled, {css} from "styled-components"
import Card from "@irati/ui/src/Layout/Card"
import {singleLine as singleLineEllipsis} from "@irati/ui/src/global/css/multiLineEllipsis"

interface CardProps {
  boxShadowColor?: boolean
}

interface DealHeaderProps {
  isUnavailable?: boolean
  hasBrandName?: boolean
  isTypeMerchandise?: boolean
}

export const DealBody = styled(Card)<CardProps>`
  ${({theme, boxShadowColor}) => css`
    border-top: 1px solid ${theme.colors.utility.highlight};
    border-radius: 0px 0px ${theme.border.radius.extraLarge} ${theme.border.radius.extraLarge};
    ${boxShadowColor && `box-shadow: inset 0px -5px 0px 0px ${boxShadowColor};`}
  `}
`

export const StyledDiv = styled.div`
  padding: ${({theme}) => `${theme.spacing.two} ${theme.spacing.oneAndHalf}`};
`

export const DealHeader = styled.div<DealHeaderProps>`
  ${({theme, isUnavailable, isTypeMerchandise, hasBrandName}) => css`
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    ${singleLineEllipsis};
    ${!hasBrandName && "padding-top: 20px;"}
    ${!isTypeMerchandise && `padding-bottom: ${theme.spacing.three};`}
    ${isUnavailable && `color: ${theme.colors.utility.contrast};`}
  `}
`
